import * as React from "react";
import {useEffect, useState} from "react";

export function ImageViewer({blob}) {
    const [imageUrl, setImageUrl] = useState(null);

    useEffect(() => {
        const url = URL.createObjectURL(blob);
        setImageUrl(url);

        // Clean up function to revoke the object URL
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [blob]);

    if (!imageUrl) {
        return <div>Loading...</div>;
    }

    return <div style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'auto'
    }}>
        <img
            src={imageUrl}
            alt="From ArrayBuffer"
            style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
            }}
        />
    </div>;
}